// Sprint notification-center (spec D3) — the Tier A chime.
//
// Synthesized with WebAudio (two short sine notes) instead of shipping
// an audio asset: no binary in the repo, no fetch, no licensing, and
// the volume/length live in code where they can be reviewed. Browsers
// block audio before the first user gesture (spec pre-mortem #3) — we
// lazily create the AudioContext and swallow every failure: the
// persistent toast is the primary signal, sound is the enhancement.
//
// New (verified no equivalent exists — nothing in web/ plays audio).

let ctx: AudioContext | null = null;

function audioContext(): AudioContext | null {
  if (typeof window === 'undefined') return null;
  const Ctor =
    window.AudioContext ??
    (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!Ctor) return null;
  if (!ctx) {
    try {
      ctx = new Ctor();
    } catch {
      return null;
    }
  }
  return ctx;
}

export function playNotificationChime(): void {
  const ac = audioContext();
  if (!ac) return;
  try {
    if (ac.state === 'suspended') {
      // Autoplay-blocked (no user gesture yet). resume() is best-effort;
      // if the browser refuses, we stay silent — by policy, not by bug.
      void ac.resume().catch(() => {});
      if (ac.state === 'suspended') return;
    }
    const now = ac.currentTime;
    // Two-note "ding-dong": E6 then A6, ~0.32 s total, gentle envelope.
    const notes: Array<{ freq: number; at: number }> = [
      { freq: 1318.5, at: now },
      { freq: 1760, at: now + 0.12 },
    ];
    for (const { freq, at } of notes) {
      const osc = ac.createOscillator();
      const gain = ac.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0, at);
      gain.gain.linearRampToValueAtTime(0.12, at + 0.015);
      gain.gain.exponentialRampToValueAtTime(0.0001, at + 0.2);
      osc.connect(gain).connect(ac.destination);
      osc.start(at);
      osc.stop(at + 0.22);
    }
  } catch {
    // Sound must never break anything.
  }
}
